export default __webpack_public_path__ + "static/media/placeholder-gold-thumbnail.bfecced0.svg";